module.exports = __webpack_public_path__ + "img/Flatbed (6).5a1af01a.jpg";